/** @jsxImportSource @emotion/react */
import  { useEffect, useMemo } from 'react'
import {  useDispatch, useSelector } from 'react-redux'
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import {  IJob } from '../../model/IFastWaveConfig';
import { IState } from '../../reducers';
import { titleContainer, titleStyle, chartContainerStyle, centerSpinnerStyle, subTitleStyle } from '../../shared/styles';
import { getJob } from '../../helpers/fastwave';
import { JOBS_IN_PROGRESS } from '../../model/IJobStatus';
import { JOBS } from '../../shared/constants';
import { useIntl } from 'react-intl';
import { getHasModelResults, getResultInitialChartData, setSelectedResultPointName } from '../../actions/projectContent';
import { useParams } from 'react-router-dom';
import { IInitialResultChartData } from '../../model/IInitialChartData';
import ResultChartContainer from '../ChartContainer/ResultChartContainer';

const Results = () => { 
  const { id } = useParams();  
  const dispatch = useDispatch();
  const intl = useIntl(); 


  const points = useSelector(
    (state: IState) => state.mapContent.points
  ); 

  const loadingResultInitialChartData: boolean  = useSelector(
    (state: IState) => state.projectContent.loadingResultInitialChartData
  ); 

  const loadingTestRunFolders: boolean  = useSelector(
    (state: IState) => state.projectContent.loadingTestRunFolders
  ); 

  const resultInitialChartData: IInitialResultChartData | null  = useSelector(
    (state: IState) => state.projectContent.resultInitialChartData
  ); 

  const hasModelResults: boolean | null  = useSelector(
    (state: IState) => state.projectContent.hasModelResults
  ); 

  const jobs: Array<IJob> = useSelector(
    (state: IState) => state.job.jobs
  );  

  const fullModelRunJobIsProcessing = useMemo(() => {   
    const job = getJob(jobs, JOBS.AUTOSETUP) 
    return job !== undefined && JOBS_IN_PROGRESS.includes(job.status.toLowerCase())    
  }, [jobs])


  useEffect(() => {   
    if (id && !hasModelResults){     
      dispatch(getHasModelResults(id))
    }
  }, [id, hasModelResults, dispatch])

  useEffect(() => {   
    if (id && hasModelResults && points && points.length > 0){   
      const pointName = points[0].id.toString() 
      dispatch(setSelectedResultPointName(pointName)) 
      dispatch(getResultInitialChartData(id, pointName))
    }
  }, [points, hasModelResults, dispatch, id])

  const getMissingDataUI = () => {
    return (
      <div>
        <Typography variant="h5" css={titleStyle}>{intl.formatMessage({id: 'results.missingData.title'})}</Typography>
        <Typography variant="body2" css={subTitleStyle}>{intl.formatMessage({id: 'results.missingData.subTitle'})}</Typography>
      </div>
    )
  }

  const getProcessingDataUI = () => {
    return (
      <div>
        <Typography variant="h5" css={titleStyle}>{intl.formatMessage({id: 'results.processingData.title'})}</Typography>
        <Typography variant="body2" css={subTitleStyle}>{intl.formatMessage({id: 'results.processingData.subTitle'})}</Typography>
        <div css={centerSpinnerStyle}><CircularProgress/></div>
      </div>
    )
  }

  return (
    <div>
      <div css={titleContainer}>
        <div>
          <Typography variant="h5" css={titleStyle}>{intl.formatMessage({id: 'results.title'})}</Typography>
          <Typography variant="body2" css={subTitleStyle}>{intl.formatMessage({id: 'results.subTitle'})}</Typography>
        </div>        
      </div>     
      <div> 
        <div css={chartContainerStyle}> 
          {fullModelRunJobIsProcessing || loadingResultInitialChartData || loadingTestRunFolders ? getProcessingDataUI() : !resultInitialChartData ? getMissingDataUI() : <ResultChartContainer/>}
        </div>        
      </div>
    </div>
  )
}

export default Results

